import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {plainToClass} from 'class-transformer';
import {TreeNode} from "primeng/api";
import {OverlayPanel} from "primeng/overlaypanel";

import {LocalCacheService} from "@app/core";
import {AbstractItem} from "@app/shared/classes/item";
import {ItemType} from "@app/shared/enums/item-type.enum";
import {Validation} from "@app/shared/enums/validation.enum";

import {CommonTransformationService} from "@app/shared/services/common-transformation.service";
import {ItemCatalogService} from "@app/shared/services/item-catalog.service";

/**
 * @author Jin Chun (October 22nd, 2018)
 * @desc used to search and select an abstract item
 */
@Component({
  selector: 'app-search-item',
  templateUrl: './search-item.component.html',
  styleUrls: ['./search-item.component.css']
})
export class SearchItemComponent implements OnInit {

  Validation: typeof Validation = Validation;

  _abstractItemId: number;
  @Input()
  set abstractItemId(itemId: number) {
    if (this._abstractItemId != itemId) {
      this._abstractItemId = itemId;
      if (itemId) {
        this.itemCatalogService.getItemById(itemId).subscribe(res => {
          this.selectedItem = plainToClass(AbstractItem, res as AbstractItem);
          this.handle.emit(this.selectedItem);
          this.itemCatalogService.getCatalogById(this.selectedItem.catalogId).subscribe(res => {
            this.selectedCatalog = res;
          });
        });
      } else {
        // if itemId is null, reset selected item and catalog so that new item can be searched and then selected
        this.selectedItem = null;
        this.selectedCatalog = null;
      }
    }
  }

  get abstractItemId(): number {
    return this._abstractItemId;
  }

  @Output() handle = new EventEmitter<AbstractItem>();

  selectedItem: AbstractItem;
  catalogTree: TreeNode[];                 // item catalog tree
  selectedCatalog: any;
  filteredItems: AbstractItem[];            // filtered items from auto complete

  constructor(private cache: LocalCacheService, private itemCatalogService: ItemCatalogService, private transform: CommonTransformationService) {
  }

  ngOnInit() {
    this.getCatalogs();
  }

  /**
   * @desc retrieve catalog tree from the backend
   */
  getCatalogs(): void {
    if (this.cache.itemCatalogs) {
      this.catalogTree = this.transform.convertToTree("name", this.cache.itemCatalogs);
    } else {
      this.itemCatalogService.getCatalogs().subscribe(catalogs => {
        this.cache.itemCatalogs = catalogs;
        this.catalogTree = this.transform.convertToTree("name", this.cache.itemCatalogs);
      });
    }
  }

  /**
   * @desc set selectedCatalog based on user's selection
   */
  nodeSelect(event, op: OverlayPanel) {

    this.selectedCatalog = event.node.data;
    op.hide();
  }

  /**
   * @desc search for items in the selected catalog, then filter those item types that ledger account can be assigned to
   */
  searchItem(event) {

    this.itemCatalogService.searchFilteredItems(this.selectedCatalog.id, event.query).subscribe(data => {
      this.filteredItems = data.list;
      this.filteredItems = this.filteredItems.filter(data => data.subtype == ItemType.Inventory || data.subtype == ItemType.NonInventory ||
        data.subtype == ItemType.FixedAsset || data.subtype == ItemType.BillOfMaterials || data.subtype == ItemType.Service || data.subtype == ItemType.Shipping || data.subtype == ItemType.SalesTax || data.subtype == ItemType.Discount || data.subtype == ItemType.OtherCharges);
    });
  }

  /**
   * @desc item is selected by the user, emit it to the parent component
   */
  onSelectItem(selectedItem: AbstractItem) {

    this.handle.emit(selectedItem);
  }
}
